import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import countriesListJson from '../../../../../assets/data/countries_codes_with_flags.json'
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {Country} from "../../../../_models/company";
import {GlobalStore} from "../../../../global.store";
import { OutsideClickDirective } from '../../../../_directives/outside-click.directive';
import { NgForOf } from '@angular/common';

@Component({
    selector: 'app-countries-code-select',
    templateUrl: './countries-code-select.component.html',
    styleUrls: ['./countries-code-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CountriesCodeSelectComponent),
            multi: true
        }
    ],
    imports: [
        OutsideClickDirective, NgForOf,
    ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class CountriesCodeSelectComponent implements ControlValueAccessor {
  @Input() isError: boolean = false;
  @Input() disabled: boolean = false;
  @Output() change = new EventEmitter<any>();

  countriesList: Country[] = [...countriesListJson];
  selectedCountry: Country;

  onChange: any = () => {};
  onTouch: any = () => {
  }

  constructor(private globalStore: GlobalStore,
              private readonly cdRef: ChangeDetectorRef) {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  findCurrentCountry(code: string, isDialCode: boolean) {
    if (isDialCode) return this.countriesList.find(country => country.dial_code === code)
    else return this.countriesList.find(country => country.code === code)
  }

  writeValue(value: any): void {
    if (!value) {
      this.selectedCountry = this.findCurrentCountry('US', false)
      this.cdRef.markForCheck();
      setTimeout(() => {
        this.onChange(this.selectedCountry.dial_code);
        this.change.emit(this.selectedCountry.dial_code);
      });
      return;
    }

    this.selectedCountry = this.findCurrentCountry(value, true)
    this.cdRef.markForCheck();
  }

  changeOption(country: Country) {
    this.selectedCountry = country;
    this.onChange(country.dial_code);
    this.change.emit(country.dial_code);
    this.cdRef.markForCheck();
  }
}
